import * as ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecord from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.http.js';
import * as ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.types.js';
import * as ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDisputeHistoryRecord(): __PublicMethodMetaInfo<
  'GET',
  { disputeHistoryRecordId: string },
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.GetDisputeHistoryRecordRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.GetDisputeHistoryRecordRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.GetDisputeHistoryRecordResponse,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.GetDisputeHistoryRecordResponse
> {
  const payload = { disputeHistoryRecordId: ':disputeHistoryRecordId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecord.getDisputeHistoryRecord(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/dispute-history-records/{disputeHistoryRecordId}',
    pathParams: { disputeHistoryRecordId: 'disputeHistoryRecordId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDisputeHistoryRecords(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.QueryDisputeHistoryRecordsRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.QueryDisputeHistoryRecordsRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.QueryDisputeHistoryRecordsResponse,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.QueryDisputeHistoryRecordsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecord.queryDisputeHistoryRecords(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/dispute-history-records/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDisputeHistoryRecordTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.BulkUpdateDisputeHistoryRecordTagsRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.BulkUpdateDisputeHistoryRecordTagsRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.BulkUpdateDisputeHistoryRecordTagsResponse,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.BulkUpdateDisputeHistoryRecordTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecord.bulkUpdateDisputeHistoryRecordTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/dispute-history-records/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDisputeHistoryRecordTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.BulkUpdateDisputeHistoryRecordTagsByFilterRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.BulkUpdateDisputeHistoryRecordTagsByFilterRequest,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordUniversalTypes.BulkUpdateDisputeHistoryRecordTagsByFilterResponse,
  ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecordTypes.BulkUpdateDisputeHistoryRecordTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsDisputeHistoryRecordsV1DisputeHistoryRecord.bulkUpdateDisputeHistoryRecordTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/dispute-history-records/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DisputeHistoryRecord as DisputeHistoryRecordOriginal,
  DisputeStage as DisputeStageOriginal,
  DisputeStageWithLiterals as DisputeStageWithLiteralsOriginal,
  DisputeStatus as DisputeStatusOriginal,
  DisputeStatusWithLiterals as DisputeStatusWithLiteralsOriginal,
  DisputeChannel as DisputeChannelOriginal,
  DisputeChannelWithLiterals as DisputeChannelWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  TagsModified as TagsModifiedOriginal,
  GetDisputeHistoryRecordRequest as GetDisputeHistoryRecordRequestOriginal,
  GetDisputeHistoryRecordResponse as GetDisputeHistoryRecordResponseOriginal,
  QueryDisputeHistoryRecordsRequest as QueryDisputeHistoryRecordsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDisputeHistoryRecordsResponse as QueryDisputeHistoryRecordsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  BulkUpdateDisputeHistoryRecordTagsRequest as BulkUpdateDisputeHistoryRecordTagsRequestOriginal,
  BulkUpdateDisputeHistoryRecordTagsResponse as BulkUpdateDisputeHistoryRecordTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateDisputeHistoryRecordTagsResult as BulkUpdateDisputeHistoryRecordTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateDisputeHistoryRecordTagsByFilterRequest as BulkUpdateDisputeHistoryRecordTagsByFilterRequestOriginal,
  BulkUpdateDisputeHistoryRecordTagsByFilterResponse as BulkUpdateDisputeHistoryRecordTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateDisputeHistoryRecordTagsApplicationErrors as BulkUpdateDisputeHistoryRecordTagsApplicationErrorsOriginal,
  BulkUpdateDisputeHistoryRecordTagsByFilterApplicationErrors as BulkUpdateDisputeHistoryRecordTagsByFilterApplicationErrorsOriginal,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.types.js';
